/**
 * Testimonial Detail Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.testimonialDetailFormatter = function(value, row) {
    let html = '';
    if (row.description) {
        html += row.description;
    }
    return html;
};
